var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9405 20.518C18.8776 20.5813 18.7695 20.5368 18.7695 20.4475L18.7695 9.14258C18.7695 8.72837 18.4337 8.39258 18.0195 8.39258C17.6053 8.39258 17.2695 8.72836 17.2695 9.14258L17.2695 20.4491C17.2695 20.5381 17.1621 20.5828 17.099 20.5201L14.0287 17.4685C13.7349 17.1765 13.26 17.1779 12.968 17.4717C12.6761 17.7655 12.6775 18.2404 12.9713 18.5324L17.499 23.0324C17.64 23.1726 17.831 23.251 18.03 23.2504C18.2289 23.2498 18.4194 23.1702 18.5596 23.0291L23.032 18.5291C23.324 18.2353 23.3225 17.7605 23.0287 17.4685C22.7349 17.1765 22.26 17.1779 21.968 17.4717L18.9405 20.518ZM9 21.7504C9.41421 21.7504 9.75 22.0862 9.75 22.5004V25.0004C9.75 25.6908 10.3096 26.2504 11 26.2504H25C25.6904 26.2504 26.25 25.6908 26.25 25.0004V22.5004C26.25 22.0862 26.5858 21.7504 27 21.7504C27.4142 21.7504 27.75 22.0862 27.75 22.5004V25.0004C27.75 26.5192 26.5188 27.7504 25 27.7504H11C9.48122 27.7504 8.25 26.5192 8.25 25.0004V22.5004C8.25 22.0862 8.58579 21.7504 9 21.7504Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLarge);
export default __webpack_public_path__ + "static/media/download-large.129dc093ddb2fd6b9eb51eec383025f6.svg";
export { ForwardRef as ReactComponent };